import { format, isValid, parseISO } from 'date-fns';

// Message Center timestamps come in the format: `January 1, 2024 8:21 AM CST`
// but they should be displayed as `January 1, 2024`
export const dateFromTimestamp = (dateStr: string) => dateStr.split(' ').slice(0, 3).join(' ');

// Formats an ISO date string (`2026-10-31`) as `October 31, 2026`.
// Unparseable input is returned unchanged.
export const formatLongDate = (dateStr: string) => {
  const parsed = parseISO(dateStr);

  return isValid(parsed) ? format(parsed, 'MMMM d, yyyy') : dateStr;
};

// Whole seconds elapsed since an epoch-ms timestamp, for coarse RUM duration attributes.
export const elapsedSeconds = (fromMs: number): number => Math.round((Date.now() - fromMs) / 1000);
